import { ISessionTokenResponseSchema } from '@cian/chats-api/lib/browser-entry';
import { NotFoundError } from '@cian/peperrors';

import { fetchUsersSession as _fetchUsersSession, TUsersSessionResponse } from '../repositories/chats/v1/users/session';
// eslint-disable-next-line import/no-cycle
import { IApplicationContext } from '../types/applicationContext';
import { EExceptionDomain } from '../types/exceptionDomains';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';

const DEFAULT_ERROR_MESSAGE = 'Неизвестная ошибка при получении токена сессии';

type TFetchUsersSessionParams = {
  cookies?: string;
  timezone?: number;
};

function isSessionToken(obj: {}): obj is ISessionTokenResponseSchema {
  return obj && 'expiration' in obj && 'sessionToken' in obj && 'userId' in obj;
}

export async function fetchUsersSession(
  { httpApi, logger }: IApplicationContext,
  { cookies, timezone }: TFetchUsersSessionParams,
) {
  try {
    const { statusCode, response }: TUsersSessionResponse = await _fetchUsersSession({
      httpApi,
      parameters: { timezone },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode >= 400) {
      // Пользователь не авторизован
      return null;
    }

    if (!isSessionToken(response)) {
      throw new NotFoundError({
        domain: EExceptionDomain.UserSession,
        message: 'Не удалось получить токен сессии',
        details: {
          errors: JSON.stringify(response),
        },
      });
    }

    return response;
  } catch (error) {
    const errorToLog = getGenericLikeError({
      error,
      domain: EExceptionDomain.UserSession,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(errorToLog, {
      microserviceName: 'chats',
      pathApi: '/v1/users/session/',
      parameters: { timezone },
    });

    return null;
  }
}
